import { render, staticRenderFns } from "./ProductReportCard.vue?vue&type=template&id=1dfc4436&"
import script from "./ProductReportCard.vue?vue&type=script&lang=js&"
export * from "./ProductReportCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports